import {
  Toaster as ChakraToaster,
  Toast,
  Portal,
  Spinner,
  Stack,
  createToaster,
} from '@chakra-ui/react';

/**
 * アプリ全体で共有する toaster インスタンス。
 * `toaster.success({ title })` / `toaster.error({ title })` で呼び出す。
 */
export const toaster = createToaster({
  placement: 'top-end',
  pauseOnPageIdle: true,
});

/**
 * Toaster プロバイダ。ルートツリー付近（main.tsx）で 1 度だけ描画する。
 */
function Toaster() {
  return (
    <Portal>
      <ChakraToaster toaster={toaster}>
        {(toast) => (
          <Toast.Root width={{ md: 'sm' }}>
            {toast.type === 'loading' ? (
              <Spinner size="sm" color="brand.solid" />
            ) : (
              <Toast.Indicator />
            )}
            <Stack gap={1} flex={1} maxWidth="100%">
              {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
              {toast.description && <Toast.Description>{toast.description}</Toast.Description>}
            </Stack>
            {toast.action && <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>}
            {toast.closable && <Toast.CloseTrigger />}
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  );
}

export { Toaster };
